import { IndicatorsResponse } from 'src/types/wallet';

export function filterFicIndicatorsForFollowingView(
  items: IndicatorsResponse[],
  operationId: string,
): IndicatorsResponse[] {
  return items
    .filter((item) => item.operation?.hashId === operationId)
    .map((item) => ({
      ...item,
      childrenWalletFunds: item.childrenWalletFunds
        ?.filter((child) => child.operation?.market?.name === 'FIDC')
        .map((child) => {
          const directChild = { ...child };
          delete directChild.childrenWalletFunds;
          return directChild;
        }),
    }));
}
